export const LIQUIDACIONES_ROUTES = {
    liquidaciones: '/Liquidaciones',
    auditoria: '/Liquidaciones/Auditoria',
    pipelines: '/Liquidaciones/Pipelines',
    pipelineDetalle: (id) => `/Liquidaciones/Pipelines/${id}`,
    comprobantes: '/Liquidaciones/Comprobantes',
    nueva: '/Liquidaciones/Nueva',
    actualizacionMasiva: '/Liquidaciones/ActualizacionMasiva',
    nuevoFee: '/Liquidaciones/NuevoFee',
    conceptos: '/Conceptos',
    conceptoNuevo: '/Conceptos/Nuevo',
    novedades: '/Novedades',
    novedadNueva: '/Novedades/Nueva',
};
